import axiosInstance from "@api/axios";
import config from "../config";
import { setExtraProperties } from '@api/amplitude';
import { isFloat, convertToFloatString } from "@helpers/totalAmountHelper";

export const setAccount = (accountData) => async dispatch => {
    dispatch({type: 'FETCH_ACCOUNT', payload: accountData});
    setExtraProperties();
};

const normalizeToArray = (data) => {
    if (Array.isArray(data)) {
      return data;
    }
    if (typeof data === 'object' && data !== null) {
      return Object.values(data);
    }
    return [];
  }


export const getExtendedProperties = (ac) => async dispatch => {
    const res = await axiosInstance.post(`${config.BOOKING_APP_API_URL}/getServices`, {
        ac: ac,
        uc: '',
        action: 'getServices'
    })

    if(res?.data?.data?.googleJobTypes?.length > 0) {
        try{
            const googleJobTypes = normalizeToArray(JSON.parse(res.data.data.googleJobTypes[0].jobtypes ?? null))?.map((jobType) => jobType.id);
            if (googleJobTypes?.length > 0) {
                dispatch({type: 'FETCH_GOOGLE_JOB_TYPES', payload: googleJobTypes});
            }
        } catch (e) {
            console.error(e);
        }
        
    
    }

    if (res?.data?.data?.services?.length > 0) {
        const extendedProperties = JSON.parse(res.data.data.services[0].extended_properties)
        const servicesObj =Object.values(extendedProperties.items||[]).filter(item=>item.status==1);
        let services = Object.keys(servicesObj).map((k) => servicesObj[k])
        services.forEach(service => {
            service.booking_price = isFloat(service.booking_price) ? convertToFloatString(service.booking_price) : service.booking_price;
        });
        if (services.length > 0) {
            dispatch({type: 'FETCH_SERVICES', payload: services});
        }

        const paymentSettings = extendedProperties.payment
        dispatch({type: 'SET_PAYMENT_SETTINGS', payload: paymentSettings});
        setExtraProperties();
        return services
    }
};